/* eslint-disable max-len */
import React from 'react';

export default function MagazineIcon() {
  return (
    <svg width="52" height="42" fill="none" viewBox="0 0 52 42">
      <path
        fill="url(#paint0_linear_10353_4336)"
        d="M26 6.904C18.832.8 8.647.492 1.174 5.975A2.832 2.832 0 000 8.255v31.267c0 1.173 1.375 1.879 2.406 1.232a19.886 19.886 0 0121.08-.067 4.81 4.81 0 005.028 0 19.886 19.886 0 0121.08.067c1.031.647 2.406-.06 2.406-1.232V8.256c0-.891-.431-1.736-1.174-2.28C43.35.49 33.166.8 26 6.903z"
      />
      <path
        fill="url(#paint1_linear_10353_4336)"
        d="M49.594 37.899a19.887 19.887 0 00-21.08-.068 4.81 4.81 0 01-5.028 0 19.887 19.887 0 00-21.08.068C1.375 38.545 0 37.839 0 36.666v2.855c0 1.173 1.375 1.88 2.406 1.233a19.887 19.887 0 0121.08-.068 4.81 4.81 0 005.028 0 19.887 19.887 0 0121.08.068C50.625 41.4 52 40.694 52 39.52v-2.855c0 1.173-1.375 1.88-2.406 1.233z"
      />
      <path
        fill="url(#paint2_linear_10353_4336)"
        d="M26 4.525c-6.385-5.728-15.457-6.017-22.113-.871a2.704 2.704 0 00-1.046 2.14v29.34c0 1.102 1.225 1.764 2.143 1.157 5.757-3.803 13.002-3.824 18.776-.063a4.1 4.1 0 004.48 0c5.773-3.76 13.018-3.74 18.775.063.919.607 2.143-.056 2.143-1.156V5.794c0-.837-.384-1.629-1.045-2.14-6.658-5.147-15.73-4.856-22.113.871z"
      />
      <path
        fill="url(#paint3_linear_10353_4336)"
        d="M28.24 36.228c5.773-3.76 13.018-3.74 18.776.063.918.607 2.143-.056 2.143-1.156V5.794c0-.837-.385-1.629-1.046-2.14-6.658-5.147-15.73-4.856-22.113.871v32.369a4.1 4.1 0 002.24-.666z"
      />
      <path
        fill="url(#paint4_linear_10353_4336)"
        d="M2.841 18.811v16.324c0 1.1 1.225 1.763 2.143 1.156 5.757-3.803 13.002-3.824 18.776-.063a4.1 4.1 0 004.48 0c5.773-3.76 13.018-3.74 18.775.063.919.607 2.143-.055 2.143-1.156V18.81H2.841z"
      />
      <path
        fill="url(#paint5_linear_10353_4336)"
        d="M47.016 31.6c-5.758-3.803-13.003-3.823-18.776-.063a4.1 4.1 0 01-4.48 0c-5.774-3.76-13.019-3.74-18.775.064-.919.607-2.143-.056-2.143-1.157v4.69c0 1.101 1.224 1.764 2.143 1.157 5.756-3.803 13.002-3.825 18.775-.063a4.1 4.1 0 004.48 0c5.773-3.761 13.018-3.74 18.776.063.918.607 2.143-.056 2.143-1.157v-4.69c0 1.101-1.225 1.764-2.143 1.157z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4336"
          x1="3.159"
          x2="51.609"
          y1="0.766"
          y2="49.215"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A2E62E" />
          <stop offset="0.123" stopColor="#97DE30" />
          <stop offset="0.34" stopColor="#79CB36" />
          <stop offset="0.623" stopColor="#4AAB3F" />
          <stop offset="0.961" stopColor="#09804C" />
          <stop offset="1" stopColor="#017B4E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4336"
          x1="26"
          x2="26"
          y1="27.325"
          y2="45.886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#017B4E" stopOpacity="0" />
          <stop offset="0.483" stopColor="#01754A" stopOpacity="0.483" />
          <stop offset="1" stopColor="#026841" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4336"
          x1="2.841"
          x2="49.158"
          y1="18.447"
          y2="18.447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF6FF" />
          <stop offset="1" stopColor="#B3DAFE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10353_4336"
          x1="26"
          x2="49.159"
          y1="18.447"
          y2="18.447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF6FF" />
          <stop offset="1" stopColor="#B3DAFE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10353_4336"
          x1="26"
          x2="26"
          y1="23.898"
          y2="36.991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8ECFE" stopOpacity="0" />
          <stop offset="0.787" stopColor="#9BD1FE" stopOpacity="0.787" />
          <stop offset="1" stopColor="#8AC9FE" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10353_4336"
          x1="26"
          x2="26"
          y1="24.47"
          y2="35.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8ECFE" stopOpacity="0" />
          <stop offset="0.787" stopColor="#9BD1FE" stopOpacity="0.787" />
          <stop offset="1" stopColor="#8AC9FE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
